/**
 * @file DeleteSearchTag
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname DeleteSearchTag
 * @classdesc 検索条件タグを追加
 */
export default class DeleteSearchTag {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('DeleteSearchTag.constructor')
		this._$e = $e
		this._$tag = $e.closest('.list-item')
		this._$list = $e.closest('.list--gray-tag')
		$e.on('click', () => this.onClick())
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof DeleteSearchTag
	 * @return {undefined}
	 */
	onClick() {
		console.log('DeleteSearchTag.onClick')
		this._$tag.remove()

		let url = this._$e.hasClass('current_search')
			? Common.getCurrentURL()
			: window.const.URL.SEARCH;
		console.log(url);

		let param = this._getSearchQuery();
		console.log(`${url}${param}`);
		location.href = `${url}${param}`;
	}

	/**
	 * 検索GETパラメーター取得
	 *
	 * @memberof Search
	 * @return {string} query - 検索GETパラメーター
	 */
	_getSearchQuery() {
		console.log('Search._getSearchQuery');
		let prefix = '?';
		let query = '';
		let dataMap = {};

		this._$list.find('[data-search-item]').each((idx, el) => {
			const $el = $(el);
			const name = $el.attr('data-search-item');
			const value = $el.attr('data-value');
			if (!dataMap[name]) {
				dataMap[name] = [];
			}

			dataMap[name].push(value); 

		});

		//選択された項目
		if (Object.keys(dataMap).length > 0) {
			console.log('dataMap::' + dataMap);
			for (var name in dataMap) {
				if (dataMap.hasOwnProperty(name)) {
					const values = dataMap[name]; 
					if(values.length > 0){
						let joinedValues = values.join('|');
						query += `${prefix}${name}=${joinedValues}`;
						prefix = '&';
					}
				}
			}
		}

		// sort
		if($('.list--search-sort')[0]){
			const $listSearchSort = $('.list--search-sort');
			const defaultSort = $listSearchSort.attr('data-default-sort');
			const active = $listSearchSort.find('.active').attr('data-sort');
			//if(defaultSort !== active) {
			if(active) {
				query += `${prefix}sort=${active}`;
				prefix = '&';
			}
		}
		//page
		if($('.pagination')[0]){
			query += `${prefix}page=1`;
			prefix = '&';
		}

		return query;
	};
}
